import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-mark',
  templateUrl: './mark.component.html',
  styleUrls: ['./mark.component.scss'],
  standalone: false,
})
export class MarkComponent implements OnInit {
  public css: number = 0;

  @Input() value: number;
  @Input() isReadOnly: boolean;

  @Output('onClickMark')
  onClickMark = new EventEmitter<number>();

  valueOver: number;

  constructor() {}

  ngOnInit(): void {
    this.css = this.value;
  }

  clickMark(value: number) {
    if (this.onClickMark && !this.isReadOnly) {
      this.onClickMark.emit(value);
      this.css = value;
    }
  }

  mouseover(value: number) {
    if (!this.isReadOnly) {
      this.valueOver = value;
    }
  }

  mouseout(value: number) {
    if (!this.isReadOnly) {
      this.valueOver = null;
    }
  }
}
